import React from 'react';
import { IonText } from '@ionic/react';
import ReferralCard from './ReferralCard';

interface IProps {
    referrals: any[];
}

const Referrals: React.FC<IProps> = (props) => {
    return (
        <>
            {Array.isArray(props.referrals) && props.referrals.map((referral, index) => <ReferralCard referral={referral} key={index} />)}
            {(!Array.isArray(props.referrals) || props.referrals.length === 0) && (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '48px 24px', gap: '8px' }}>
                    <IonText color="medium" style={{ fontSize: '14px' }}>No referrals found</IonText>
                    <IonText color="medium" style={{ fontSize: '13px' }}>Pull to refresh</IonText>
                </div>
            )}
        </>
    );
};

export default Referrals;
